<template>
  <v-card class="card">
    <slot></slot>
  </v-card>
</template>

<style scoped>
.card {
  border-radius: 12px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.99);
  padding: 0.3rem;
  margin: 2rem auto;
  max-width: 22rem;
}
</style>
